import { Link } from "react-router-dom";

interface RelatedItem {
  id: string;
  title: string;
  boardName: string;
  replies: number;
}

export default function RelatedTopics({
  items,
  boardId,
  boardName,
}: {
  items: RelatedItem[];
  boardId: string;
  boardName: string;
}) {
  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
          <i className="ri-links-line text-primary-600" />
          相关讨论推荐
        </h2>
        <ul className="mt-3.5 space-y-3.5">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={`/topic/${item.id}`}
                className="block text-sm font-medium leading-snug text-foreground-800 transition-colors hover:text-primary-700"
              >
                {item.title}
              </Link>
              <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
                  {item.boardName}
                </span>
                {item.replies} 回帖
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
        <h2 className="flex items-center gap-1.5 text-sm font-semibold text-primary-800">
          <i className="ri-chat-thread-line" />
          同板块更多话题
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          想看更多「{boardName}」的讨论？进入板块可以浏览全部帖子并参与回帖。
        </p>
        <Link
          to={`/topics?board=${boardId}`}
          className="mt-4 flex h-10 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-right-circle-line" />
          进入「{boardName}」
        </Link>
      </div>
    </aside>
  );
}